<template>
  <OwnCard
    :el="el"
    class="own-option w-full"
    :class="{
      'own-option--button': el === 'button',
      'own-option--selected': active,
    }"
    control
    :disabled="disabled ? 'disabled' : undefined"
    v-bind="el === 'button' && { type: 'button' }"
  >
    <slot />
  </OwnCard>
</template>

<script lang="ts" setup>
import { OwnCard } from '../OwnCard'

withDefaults(
  defineProps<{
    active?: boolean
    disabled?: boolean
    el?: string
  }>(),
  {
    active: false,
    disabled: false,
    el: 'button',
  }
)
</script>

<style lang="scss">
@use '@/styles/globals';

.own-option {
  padding: 7px 12px;

  transition:
    globals.transitionOne(background-color),
    globals.transitionOne(opacity),
    transform 0.1s cubic-bezier(0.23, 1, 0.32, 1);

  &--selected {
    background-color: var(--background-active);
  }

  &--button {
    cursor: default;

    &:hover {
      background-color: var(--background-active);
      opacity: 1;

      &:disabled {
        cursor: text;
        user-select: text;
      }
    }

    &:active:not(:disabled) {
      transform: scale(0.98);
    }
  }
}
</style>
